import React from "react";
import { newsData } from "../constants";
import { ShortDate } from "./smComponents/ShortDate";
export const NewsSection = () => {
  return (
    <div className="max-width">
      <div className="wr-cg-3  mw-ct">
        {newsData.map(({ id, title, isPrimerEquipo }) => {
          return (
            <div className="news-card" key={id}>
              <div className="cgi-3-news">
                <span className={`arti${id}`}></span>
              </div>
              <div className="card-body">
                <ShortDate isPrimerEquipo={isPrimerEquipo} />
                <h3 className="article-heading">{title}</h3>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
